import { components } from 'react-select';

import { Option as OptionType } from '@trukt/portal-utils/Option';

import { Typography } from '../../../../../Typography';
import { OptionProps } from './Option.types';
import { useStyles } from './Option.styles';

import { SelectOptionProps } from '../../SelectOption.types';

export const Option = (props: OptionProps) => {
  const styles = useStyles({ isSelected: props.isSelected, isFocused: props.isFocused });
  const option = props?.data as OptionType;

  const selectProps = props.selectProps as unknown as SelectOptionProps;

  const optionIndex = selectProps.options?.findIndex((item) => item.value === option.value);

  return (
    <components.Option css={styles.root} {...props}>
      {selectProps.optionFormatter ? (
        selectProps.optionFormatter(
          {
            option,
            variant: 'option',
          },
          optionIndex,
        )
      ) : (
        <>
          <Typography className="capitalize" css={styles.label}>
            {option.label}
          </Typography>
        </>
      )}
    </components.Option>
  );
};
